import BaseError from "./BaseError";

export default class BadRequestError extends BaseError {
  constructor(message: string, info?: any, cause?: Error) {
    super({
      statusCode: 400,
      message,
      info: info || null,
      cause,
    });
    this.name = "BadRequestError";
  }
}
